import { fileUrl } from "../lib/api";
import { BRAND_COLORS } from "../lib/bookingStatus";

/**
 * Circular avatar with a photo fallback to Weissblom-style initials chip.
 *
 * Props:
 *  - name: full name used for initials fallback
 *  - fileId: bare file id from `avatar_file_id` (rendered via /api/files/{id})
 *  - size: pixel size (default 32)
 *  - testid: optional data-testid
 */
export default function Avatar({ name = "", fileId, size = 32, testid }) {
  const initials = (name || "?")
    .split(" ")
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const style = {
    width: size,
    height: size,
    background: BRAND_COLORS.navy,
    color: BRAND_COLORS.gold,
    fontSize: size <= 28 ? 10 : size <= 40 ? 12 : 14,
  };
  if (fileId) {
    return (
      <span
        className="rounded-full overflow-hidden inline-flex items-center justify-center shrink-0 ring-1 ring-gold/40"
        style={{ width: size, height: size }}
        data-testid={testid}
        title={name}
      >
        <img
          src={fileUrl(fileId)}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      </span>
    );
  }
  return (
    <span
      className="rounded-full inline-flex items-center justify-center shrink-0 font-medium ring-1 ring-gold/30"
      style={style}
      data-testid={testid}
      title={name}
    >
      {initials || "?"}
    </span>
  );
}
